import type { SidebarMenuItem } from '../../types';

export const getDividerItem = (): SidebarMenuItem => ({
  type: 'divider',
});
